import { InputNumber, message, Table, TableColumnsType } from 'antd'
import { CopyOutlined } from '@ant-design/icons';
import './index.less'
import CopyToClipboard from 'react-copy-to-clipboard';
import { useTranslation } from 'react-i18next';
import { formatNumber, strDot, updateAddress } from '@/utils';
import MyIcon from '@/router/Icon';
import Loader from '@/components/Loader';
import { DataType } from '../../interface';
import TransactionTag from '@/components/TransactionTag';

export default function WalletAddressFinallyTable({
  listLoading,
  progress,
  wallets,
  onImport,
  mintAddress,
  onSelectWallet,
  queryList,
  postAccountOverview,
  onDelWallet,
  handleWalletInputChange,
  symbol,
  basicInfo,
  coinType
}: any) {
  const { t } = useTranslation();
  function onCopy() {
    message.success(t("tips.copy"));
  }

  function onDel(key: any) {
    const newWallets = wallets.filter((item: any, idx: number) => item.key !== key);

    if (onDelWallet) {
      onDelWallet(newWallets);
    }
  }


  function switchStatus(row: any) {
    if (Number(row.status) === 0) {
      return <TransactionTag status={"noStart"} txt={t("batchTransfer.notExecuted")} />;
    }
    if (Number(row.status) === 1) {
      return <TransactionTag status={"loading"} txt="" />;
    }

    if (Number(row.status) === 2) {
      return <TransactionTag status={"success"} txt={t("batchTransfer.success")} hash={row.tx} onCopy={onCopy} />;
    }

    if (Number(row.status) === 3) {
      return <TransactionTag status={"fail"} txt={t("batchTransfer.failure")} hash={row.tx} />;
    }

    return <></>;
  }

  const columns: TableColumnsType<DataType> = [
    {
      title: '#',
      dataIndex: 'key',
      key: 'key',
      align: 'center',
      width: "10%",
      render: (_, record, index) => (
        <div className="custom-td">
          <p>{index + 1}</p>
        </div>
      )
    },
    {
      title: t("manyToMany.sendingAddress"),
      dataIndex: 'walletAddress',
      key: 'walletAddress',
      align: 'center',
      width: "20%",
      render: (_, record) => (
        <CopyToClipboard text={`${record.walletAddress}`} onCopy={() => { onCopy() }}>
          <div className="custom-td" style={{ cursor: "pointer" }}>
            <p style={{ marginRight: '5px' }}>{strDot(record.walletAddress)}</p>
            <CopyOutlined />
          </div>
        </CopyToClipboard>
      )
    },
    {
      title: t("manyToMany.recipientAddress"),
      dataIndex: 'toAddress',
      key: 'toAddress',
      align: 'center',
      width: "20%",
      render: (_, record) => (
        <CopyToClipboard text={`${record.toAddress}`} onCopy={() => { onCopy() }}>
          <div className="custom-td" style={{ cursor: "pointer" }}>
            <p style={{ marginRight: '5px' }}>{strDot(record.toAddress)}</p>
            <CopyOutlined />
          </div>
        </CopyToClipboard>
      )
    },
    {
      title: t("manyToMany.sendQuantity", { symbol: basicInfo.symbol }),
      dataIndex: 'opAmount',
      key: 'opAmount',
      align: 'center',
      width: "25%",
      render: (_, record) => (
        <p>{`${Number(record.opAmount) >= 1000 ? formatNumber(Number(record.opAmount)) : record.opAmount} ${basicInfo.symbol}`}</p>
      ),
    },
    {
      title: t("batchTransfer.status"),
      key: 'action',
      align: 'center',
      width: "25%",
      render: (_, record) => (
        switchStatus(record)
      ),
    },
  ];
  return (<div className="wallet-address-finally-table">
    <Table
      columns={columns}
      rowClassName={() => 'custom-row'}
      dataSource={wallets}
      rowKey="key"
      pagination={false}
      scroll={{ y: 480 }}>
    </Table>
  </div>)
}